// utils/collectionKinds.js
//
// What KIND of collection this is, read off the server's own fields — one
// reader for the tile tag, the context bar kicker, the rail and the settings
// page, so they can never disagree (docs/plans/personal-discover-global.md
// §2.5, §4).
//
//   kind: 'personal'   the account's own collection, made by the server;
//                      cannot be deleted, archived or transferred
//   kind: 'archive'    a retired global collection's referenced records,
//                      held by keepr
//   publication.state  'published' | 'retiring' → a global collection,
//                      readable by every signed-in account
//   sharing            { grants, groups } — the list endpoint's counts, on
//                      rows the caller manages only
//
// Absent fields are the ordinary collection: an API a deploy behind (no
// `kind`, no `sharing`) reads as "nothing special", never as an error.

import { isOwner } from './permissions';

const GLOBAL_STATES = ['published', 'retiring'];

export function isPersonal(collection) {
	return collection?.kind === 'personal';
}

export function isArchiveKind(collection) {
	return collection?.kind === 'archive';
}

export function isGlobal(collection) {
	return GLOBAL_STATES.includes(collection?.publication?.state);
}

/** The owner's view: at least one grant or group on the collection. */
export function isSharedByMe(collection) {
	if (!collection || !isOwner(collection)) return false;
	const sharing = collection.sharing;
	if (!sharing || typeof sharing !== 'object') return false;
	return ((Number(sharing.grants) || 0) + (Number(sharing.groups) || 0)) > 0;
}

/** The tag a tile's meta line carries: Personal · Archive · Global · Shared, or null. */
export function kindLabel(collection) {
	if (isPersonal(collection)) return 'Personal';
	if (isArchiveKind(collection)) return 'Archive';
	if (isGlobal(collection)) return 'Global';
	if (isSharedByMe(collection)) return 'Shared';
	return null;
}

/**
 * The line the context bar shows beside the breadcrumb, or null for an
 * ordinary collection (whose bar already says "Collections").
 */
export function kindKicker(collection) {
	if (isPersonal(collection)) return 'Personal collection';
	if (isArchiveKind(collection)) return 'keepr archive';
	if (isGlobal(collection)) return 'Global collection';
	return null;
}
